import { WebSocketInterceptor } from '@mswjs/interceptors/WebSocket'

export const webSocketInterceptor = new WebSocketInterceptor()
